var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBrandPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.511 13.1396L12.8366 0.599609H12.7116C6.62298 0.617763 1.6916 5.65393 1.67383 11.8719V11.9996L14.511 13.1396Z",
    fill: "#ED6C47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9629 0.599609H12.8379V11.9996L18.4193 14.2796L24.0007 11.9996V11.8719C23.9829 5.65393 19.0515 0.617763 12.9629 0.599609Z",
    fill: "#FF8F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9994 12V12.1254C23.9819 18.3448 19.0494 23.3822 12.9594 23.4H12.7138C6.62386 23.3822 1.6913 18.3448 1.67383 12.1254V12H23.9994Z",
    fill: "#D35230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.3948 6.20326V18.3671C13.392 18.7897 13.1412 19.1694 12.7585 19.3304C12.6366 19.383 12.5057 19.4101 12.3734 19.4102H4.30826C4.15198 19.2278 4.00129 19.034 3.86175 18.8402C2.43977 16.9029 1.67199 14.5467 1.67384 12.1256V11.8748C1.67058 9.69099 2.29552 7.55433 3.47105 5.73016C3.59384 5.53636 3.72221 5.34256 3.86175 5.16016H12.3734C12.9357 5.16451 13.3905 5.62899 13.3948 6.20326Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8366 6.77357V18.9374C12.8366 19.0725 12.81 19.2062 12.7585 19.3307C12.6009 19.7215 12.2291 19.9776 11.8152 19.9805H4.81617C4.63958 19.7974 4.47014 19.6072 4.30826 19.4105C4.15198 19.2281 4.00129 19.0343 3.86175 18.8405C2.43977 16.9032 1.67199 14.547 1.67384 12.1259V11.8751C1.67058 9.6913 2.29552 7.55465 3.47105 5.73047H11.8152C12.3776 5.73481 12.8324 6.19929 12.8366 6.77357Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8366 6.77356V17.7974C12.8324 18.3716 12.3776 18.8361 11.8152 18.8405H3.86175C2.43977 16.9032 1.67199 14.547 1.67384 12.1259V11.8751C1.67058 9.6913 2.29552 7.55465 3.47105 5.73047H11.8152C12.3776 5.7348 12.8324 6.19927 12.8366 6.77356Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.2785 6.77356V17.7974C12.2742 18.3716 11.8194 18.8361 11.2571 18.8405H3.86175C2.43977 16.9032 1.67199 14.547 1.67384 12.1259V11.8751C1.67058 9.6913 2.29552 7.55465 3.47105 5.73047H11.2571C11.8194 5.7348 12.2742 6.19927 12.2785 6.77356Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02306 5.73047H11.256C11.821 5.73047 12.2791 6.19825 12.2791 6.77527V17.2257C12.2791 17.8027 11.821 18.2705 11.256 18.2705H1.02306C0.458049 18.2705 0 17.8027 0 17.2257V6.77527C0 6.19825 0.458049 5.73047 1.02306 5.73047Z",
    fill: "url(#paint0_linear_6643_23255)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25079 8.51629C6.91692 8.47038 7.57731 8.66798 8.11386 9.07375C8.56137 9.48176 8.80049 10.0771 8.76241 10.6886C8.76973 11.1136 8.65882 11.532 8.44261 11.8952C8.2237 12.2522 7.90832 12.5369 7.53451 12.7149C7.10716 12.9179 6.63993 13.0181 6.16873 13.0079H4.87441V15.4646H3.54883V8.51629H6.25079ZM4.8733 11.9466H6.01414C6.37581 11.9737 6.73467 11.8644 7.02271 11.6393C7.26094 11.4059 7.3858 11.0768 7.36373 10.7404C7.36373 9.97473 6.928 9.59188 6.05657 9.59188H4.87331V11.9466H4.8733Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6643_23255",
    x1: 2.13312,
    y1: 4.91408,
    x2: 10.4013,
    y2: 18.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrandPowerpoint);
export default __webpack_public_path__ + "static/media/logo-brand-powerpoint.a02a056b411cd0ad96ae71f57438db97.svg";
export { ForwardRef as ReactComponent };